import { render, staticRenderFns } from "./AttachmentView.vue?vue&type=template&id=52edee4b&scoped=true"
import script from "./AttachmentView.vue?vue&type=script&lang=js"
export * from "./AttachmentView.vue?vue&type=script&lang=js"
import style0 from "./AttachmentView.vue?vue&type=style&index=0&id=52edee4b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52edee4b",
  null
  
)

export default component.exports